"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentManagerScripts = exports.TranscendConsentBanner = exports.GtagInline = exports.TranscendConsentScript = void 0;
const react_1 = __importDefault(require("react"));
const script_1 = __importDefault(require("next/script"));
const TranscendConsentScript = () => {
    return (react_1.default.createElement(script_1.default, { id: "transcend-consent-script", dangerouslySetInnerHTML: {
            __html: `
                var checkoutExternalUrls = [
                    '/checkout-external',
                    '/tickets-external',
                    '/signin/checkout',
                ];

                window.EB = window.EB || {};

                window.EB.TranscendConsent = (function () {
                    return {
                        shouldDisableTranscend: function () {
                            if(this.isEmbeddableContent()){
                                return true;
                            }
                            try {
                                return this.isCheckoutOrIframe();
                            } catch (e) {
                                return true;
                            }
                        },
                        isEmbeddableContent: function () {
                            return this.isEmbeddableStructuredContent();
                        },
                        isEmbeddableStructuredContent: function () {
                            var structuredContenEmbeddableUrls = [
                                '/structured_content/widgets',
                            ];
                            if(structuredContenEmbeddableUrls.find(function(url){
                                return window.location.pathname.indexOf(url) !== -1;
                            })){
                                return true;
                            }
                            return false;
                        },
                        isCheckoutOrIframe: function () {
                            return (
                                checkoutExternalUrls.indexOf(window.location.pathname) >= 0 ||
                                this.isInsideIframe()
                            );
                        },
                        isInsideIframe: function () {
                            try {
                                return window.self !== window.top;
                            } catch (e) {
                                return true;
                            }
                        },
                        isNonTld: function () {
                            try {
                                return !['evbdev', 'evbqa', 'eventbrite'].find(
                                    (env) => window.parent.location.hostname.indexOf(env) >= 0,
                                );
                            } catch (e) {
                                return true;
                            }
                        },
                        isInsideNonTldIframe: function () {
                            return this.isInsideIframe() && this.isNonTld();
                        },
                    };
                })();
                `,
        } }));
};
exports.TranscendConsentScript = TranscendConsentScript;
const GtagInline = () => {
    return (react_1.default.createElement(script_1.default, { id: "gtag-inline", dangerouslySetInnerHTML: {
            __html: `
                window.dataLayer = window.dataLayer || [];
                if (typeof gtag !== 'function') function gtag(){ dataLayer.push(arguments); }
                gtag('set', 'developer_id.dOGRkZj', true);

                // Europe is opt-in consent, so ad storage is denied by default.
                gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied',
                    'region': ['AT','BE','BG','CZ','DE','DK','ES','FI','FR','GB','GR','HU','IE','IT','LU','NL','PL','PT','RO','SE','BR','TH','TR'],
                    'wait_for_update': 500
                });

                // Passing ad click, client ID, and session ID information in URLs
                gtag('set', 'url_passthrough', true);
                `,
        } }));
};
exports.GtagInline = GtagInline;
const TranscendConsentBanner = () => (react_1.default.createElement(script_1.default, { id: "transcend-consent-banner", dangerouslySetInnerHTML: {
        __html: `
            const regimes = window.airgap && window.airgap.getRegimes ? window.airgap.getRegimes() : null;
            const defaultRegime = regimes ? regimes.values().next().value : "CPRA";
            console.log("Regime detected is "+ defaultRegime + ", loading transcend")
            if (!EB.TranscendConsent.shouldDisableTranscend()) {
                    // Add the event listener
                    window.airgap.addEventListener(
                      'sync',
                      () => {
                        window.transcend.ready((transcend) => {
                          console.log("Sync done via valkriye: Show banner")
                          transcend.autoShowConsentManager();
                        })
                      },
                      { once: true } // we only want this to run on initial sync
                    );
            }else{
                    console.log("Do not show banner")
            }
            dataLayer.push({ event: "transcendLoaded" });
            `,
    } }));
exports.TranscendConsentBanner = TranscendConsentBanner;
const ConsentManagerScripts = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.TranscendConsentScript, null),
        react_1.default.createElement(exports.GtagInline, null),
        react_1.default.createElement(exports.TranscendConsentBanner, null)));
};
exports.ConsentManagerScripts = ConsentManagerScripts;
//# sourceMappingURL=ConsentManager.js.map